<div class="tw-flex tw-items-center tw-justify-center tw-h-full tw-cursor-pointer">
  <app-checkbox
    [title]="''"
    [checked]="isMasked()"
    [disabled]="disabled"
    [background]="'primary'"
    (onChange)="onToggle()"
  ></app-checkbox>
</div>
